import type { FC } from 'react';
import { useEffect, useState } from 'react';

import { Text } from '@opendoor/bricks-next';
import { usePath } from 'shared/hooks/usePath';

/**
 * Announce internal page navigation to screen readers
 * @see https://estevanmaito.me/blog/accessible-navigation-using-react-router
 */
export const InternalNavA11yAnnouncer: FC = () => {
  const [a11yMessage, setA11yMessage] = useState('');
  const path = usePath();

  useEffect(() => {
    // make sure navigation has occurred and screen reader is ready
    const timeout = setTimeout(() => setA11yMessage(`Navigated to the ${path} page.`), 500);

    return () => clearTimeout(timeout);
  }, [path]);

  return (
    <Text
      tag="span"
      typography="$bodyMedium"
      className="sr-only"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {a11yMessage}
    </Text>
  );
};
